import React from 'react';
import classNames from 'classnames';
import { t } from '../../../../../i18n';
import { tickIcon } from '../../../../assets';
import './styles.scss';

const Goals = ({ goals, className }) => {
  if (goals.length === 0) {
    return null;
  }
  return (
    <div className={classNames('specific-course-screen__goals', className)}>
      <h2>{t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.OVERVIEW.GOALS_TITLE')}</h2>
      <ul className="specific-course-screen__goals-list">
        {goals.map((goal, index) => (
          <li key={index} className="specific-course-screen__goal-item">
            <img src={tickIcon} alt="tick" />
            <div>{goal.statement}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Goals;
